import React, {Component} from 'react';
import PropTypes from "prop-types";

class UserAboutContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        requestUserData: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.translate = this.props.baseData.translate;
        this.package = this.props.baseData.package;

    }

    render() {

        return (
            <div className="formSettings">
                <nav>
                    <h1 data-i18n="version">{this.translate('aboutMyZsk')}</h1>
                </nav>

                <div className="formRow">
                    <table>
                        <tbody>
                            <tr>
                                <td className="text-left labelSpan">{this.translate('version')}</td>

                                <td className="text-left">
                                    <input name="validUntill"
                                           type="text"
                                           value={this.package.version}
                                           disabled={true}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );

    }

}

export default UserAboutContainer;